import data from './data'
import components from './components'
import methods from './methods'
import mounted from './mounted'

export default {
  data,
  components,
  methods,
  mounted,
  resourcePath: '/v1/dweller/accountability'
}



// WEBPACK FOOTER //
// ./src/app/tenant/accountability/resources/index.js